export function GetToken() {
	return sessionStorage.getItem("user");
}
export function SetToken(val) {
	return sessionStorage.setItem("user", val)
}
export function downLoadCode(config) {
	let f = document.createElement("form");
	f.action = config.url;
	f.method = "POST";
	f.target = "";
	f.style.display = "none";
	document.body.appendChild(f);
	if (config.data) {
		for (let key in config.data) {
			let i = document.createElement("input");
			i.type = "hidden";
			i.value = config.data[key];
			i.name = key;
			f.appendChild(i);
		}
	}
	f.submit();
	document.body.removeChild(f);
}

export function toast(message) {
	this.$notify({
		title: '温馨提示',
		message: message,
		position: 'top-right'
	});
}


/**
 * 字符串是否为空
 */
export function m_empty(obj) {
	if (typeof obj == undefined || obj == null || obj == "") {
		return true;
	} else {
		return false;
	}
}
